import moment from 'moment';
import 'moment/locale/es';
export var dateFormat = function (date, format) {
    moment.locale('es');
    return date === null ? '' : moment(date).format(format);
};
